import { ReactComponent as XIcon } from "assets/icons/x-icon.svg";

interface ModalCloseButtonProps {
  onClick: () => void;
}

export default function ModalCloseButton({ onClick }: ModalCloseButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
      aria-label="Close"
    >
      <XIcon className="w-3 h-3" />
    </button>
  );
}
